
import { Component, Vue } from "vue-property-decorator";
import { UserService, GaodeService, WechatService, supplierService, dingtalkService } from "src/services";
import { Toast } from "vant";
import { tools } from "src/utils";
import { ILogin } from "src/model";
import { DesSecretUtils } from "src/utils";
import privacy from "./privacy.vue";
import agreement from "./agreement.vue";
import ermInfo from "./ermInfo.vue";
import globalConfig from "../config/index";
import Register from "./register.vue";
import dd from "dingtalk-jsapi";

Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate", // for vue-router 2.2+
]);

@Component({
  components: {
    agreement,
    privacy,
    ermInfo,
    Register,
  },
})
export default class Login extends Vue {
  /**
   * 显示协议弹框
   * @private
   * @returns boolean
   */
  private showOverlay: boolean = false;

  /**
   * 服务隐私协议id
   * @private
   * @returns number
   */
  private ermInfoId: number = null;

  /**
   * 是否显示服务隐私协议
   * @private
   * @returns number
   */
  private showErmInfoModal: boolean = false;

  /**
   * 是否显示服务协议
   * @private
   * @returns boolean
   */
  private showAgreement: boolean = false;

  /**
   * 是否显示隐私协议
   * @private
   * @returns boolean
   */
  private showPrivacy: boolean = false;

  /**
   * 是否在钉钉环境
   * @private
   * @returns boolean
   */
  private isDingTalkEnv: boolean = false;

  /**
   * 是否显示钉钉自动登录遮罩
   * @private
   * @returns boolean
   */
  private showDingTalkAutoLogin: boolean = false;

  /**
   * 钉钉自动登录倒计时（秒）
   * @private
   * @returns number
   */
  private dingTalkCountdown: number = 1;

  /**
   * 自动登录定时器
   * @private
   * @returns number
   */
  private autoLoginTimer: number = null;

  /**
   * 是否已经取消自动登录
   * @private
   * @returns boolean
   */
  private isAutoLoginCanceled: boolean = false;

  /**
   * 是否默认记录密码
   * @private
   * @returns boolean
   */
  private isRememberPassword: boolean = false;

  /**
   * 是否同意协议
   * @private
   * @returns boolean
   */
  private checkedAgreement: boolean = false;

  /**
   * 登录数据模型
   * @private
   * @returns ILogin
   */
  private modelData: ILogin = {
    code: "", // 企业编号
    account: "", // 登入账号
    password: "", // 登入密码
    loginType: null, // 登录类型
  };

  /**
   * 是否显示密码
   * @private
   * @returns string
   */
  private showPwd: boolean = false;

  /**
   * 获取当前登入机构信息
   * @private
   * @returns void
   */
  private get tip(): any {
    let appid = localStorage.getItem("appid");
    let employerConfig = globalConfig.employerConfig[appid];
    let tempData = this.loginTypes.filter((res) => res.loginType == this.modelData.loginType);

    let accountTip=null;
        if(employerConfig&&employerConfig.accountTip1&&this.modelData.loginType==1){
          accountTip=employerConfig.accountTip1;
        }
        if(employerConfig&&employerConfig.accountTip2&&this.modelData.loginType==2){
          accountTip=employerConfig.accountTip2;
        }
        if(employerConfig&&employerConfig.accountTip3&&this.modelData.loginType==3){
          accountTip=employerConfig.accountTip3;
        }

        if(accountTip==null){           
           if(employerConfig&&employerConfig.accountTitle1&&this.modelData.loginType==1){
              let tempData1 =this.loginTypes.filter((res) => res.loginType == 1);
              accountTip=employerConfig.accountTitle1;
            }
            if(employerConfig&&employerConfig.accountTitle2&&this.modelData.loginType==2){
              let tempData2 = this.loginTypes.filter((res) => res.loginType == 2);
              accountTip=employerConfig.accountTitle2;
            }
            if(employerConfig&&employerConfig.accountTitle3&&this.modelData.loginType==3){
              let tempData3 = this.loginTypes.filter((res) => res.loginType == 3);
              accountTip=employerConfig.accountTitle3;
            }
        }

        if(accountTip==null&&tempData&&tempData.length&&tempData[0].loginTypeStr){      
          accountTip=tempData[0].loginTypeStr;
        }

    return {
      accountTip:accountTip || "手机号",
      pwdTip: (employerConfig && employerConfig.pwdTip) || "密码",
    };
  }

  /**
   * 获取当前登入机构信息
   * @private
   * @returns void
   */
  private get hasInputForm(): any {
    if (this.modelData.account && this.modelData.password) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 是否显示注册
   * @private
   * @returns void
   */
  private get showRegister(): any {
    return this.orgInfo.isOpenRegister || false;
  }

  /**
   * 获取当前登入机构信息
   * @private
   * @returns void
   */
  private get orgInfo(): any {
    return this.$store.getters.orgInfo || {};
  }

  /**
   * 获取routeName
   * @private
   * @returns void
   */
  private get routeName(): any {
    return this.$route.query.routeName || "";
  }

  /**
   * 组件创建钩子
   * @private
   * @returns void
   */
  private created(): void {
    localStorage.removeItem("isFormAi");
    localStorage.removeItem("openid");
    localStorage.removeItem("perfectUserInfo");
    this.modelData.code = localStorage.getItem("appid");

    // 检测钉钉环境
    this.checkDingTalkEnv();

    // 获取机构信息
    this.getOrgInfo(this.modelData.code);

    this.checkSSOLogin(this.modelData.code);
  }

  /**
   * 开始钉钉自动登录
   * @private
   * @returns void
   */
  private startDingTalkAutoLogin(): void {
    if (!this.isDingTalkEnv || this.isAutoLoginCanceled) {
      return;
    }
    
    console.log("[钉钉登录调试] 开始自动登录流程");
    
    // 显示自动登录遮罩
    this.showDingTalkAutoLogin = true;
    this.dingTalkCountdown = 1;
    
    // 启动倒计时
    this.autoLoginTimer = window.setInterval(() => {
      this.dingTalkCountdown--;
      
      if (this.dingTalkCountdown <= 0) {
        this.cancelAutoLoginTimer();
        // 倒计时结束，执行自动登录
        this.doDingTalkAutoLogin();
      }
    }, 1000);
  }

  /**
   * 取消自动登录定时器
   * @private
   * @returns void
   */
  private cancelAutoLoginTimer(): void {
    if (this.autoLoginTimer) {
      clearInterval(this.autoLoginTimer);
      this.autoLoginTimer = null;
    }
  }

  /**
   * 取消自动登录
   * @private
   * @returns void
   */
  private cancelAutoLogin(): void {
    console.log("[钉钉登录调试] 用户取消自动登录");
    this.cancelAutoLoginTimer();
    this.showDingTalkAutoLogin = false;
    this.isAutoLoginCanceled = true;
  }

  /**
   * 执行钉钉自动登录
   * @private
   * @returns void
   */
  private async doDingTalkAutoLogin(): Promise<void> {
    console.log("[钉钉登录调试] 执行自动登录");
    this.showDingTalkAutoLogin = false;
    
    try {
      await this.onDingTalkLogin();
    } catch (err) {
      console.error("[钉钉登录调试] 自动登录失败:", err);
      // 自动登录失败，不做任何操作，用户可以手动登录
    }
  }

  /**
   * 组件销毁时清理定时器
   * @private
   * @returns void
   */
  private beforeDestroy(): void {
    this.cancelAutoLoginTimer();
  }

  /**
   * 检测钉钉环境
   * @private
   * @returns void
   */
  private checkDingTalkEnv(): void {
    const ua = navigator.userAgent.toLowerCase();
    this.isDingTalkEnv = ua.includes("dingtalk");
    console.log("[钉钉登录调试] UserAgent:", ua);
    console.log("[钉钉登录调试] 钉钉环境检测结果:", this.isDingTalkEnv);
    
    // 检查dd对象是否存在
    if (typeof dd !== 'undefined') {
      console.log("[钉钉登录调试] dd对象已加载");
    } else {
      console.warn("[钉钉登录调试] dd对象未加载，请检查钉钉SDK是否正确引入");
      if (this.isDingTalkEnv) {
        // 在钉钉环境中但dd对象未加载，可能是SDK引入问题
        setTimeout(() => {
          if (typeof dd !== 'undefined') {
            console.log("[钉钉登录调试] dd对象延迟加载成功");
          } else {
            console.error("[钉钉登录调试] dd对象加载失败，请检查SDK引入");
          }
        }, 2000);
      }
    }
  }

    /**
   * 检测单点登录参数
   * @private
   * @returns void
   */
  private async checkSSOLogin(code : string): Promise<void> {
    let ssoKey = this.$route.query.key;
    console.log('checkSSOLoginssoKey',ssoKey);
    if (Array.isArray(ssoKey)) {
      ssoKey = ssoKey[0];
    }

    localStorage.setItem("ssoKey", ssoKey);
    if (ssoKey) {
      await this.doSSOLogin(ssoKey,code);
    } else {
    }
  }

    private async doSSOLogin(key: string, code: string): Promise<void> {
    try {
      const { content: result } = await UserService.instance.SSOLogin({
        Code: code,
        Key: key
      });
      console.log('doSSOLoginresult',result);
      this.$store.dispatch("setLoginInfo", result.data);
      this.$nextTick(() => {
        this.$router.replace({ name: "home" });
      });
    } catch (err) {
      console.warn("SSO登录失败:", err.message || err.msg || err);
    }
  }

  /**
   * 记住密码重新赋值
   * @private
   * @returns void
   */
  private onSetModelData(): void {
    let loginDataStr = localStorage.getItem("loginData");
    if (loginDataStr) {
      if (
        this.orgInfo.isUnited ||
        this.loginTypes.some((res) => res.loginType == JSON.parse(DesSecretUtils.encrypt(loginDataStr)).loginType)
      ) {
        this.isRememberPassword = true;
        this.modelData = JSON.parse(DesSecretUtils.encrypt(loginDataStr));
      }
    }
  }

  /**
   * 登录类型
   * @private
   * @returns any
   */
  private loginTypes: Array<any> = [];

  /**
   * 获取机构详情
   * @private
   * @returns void
   */
  private async getOrgInfo(code: string): Promise<void> {
    try {
    let appid = localStorage.getItem("appid");
    let employerConfig = globalConfig.employerConfig[appid];
   

      let { content: result } = await UserService.instance.getOrgInfo(code);
      if (result.data) {
        if (!result.data.isUnited && result.data.loginTypes) {
          this.loginTypes = result.data.loginTypes;
          if (this.loginTypes.length > 0) {
            this.modelData.loginType = this.loginTypes[0].loginType;
          }
        }

    if(employerConfig&&employerConfig.accountTitle1){
          let tempData1 =result.data.loginTypes.filter((res) => res.loginType == 1);
          tempData1[0].loginTypeStr=employerConfig.accountTitle1;
        }
        if(employerConfig&&employerConfig.accountTitle2){
          let tempData2 = result.data.loginTypes.filter((res) => res.loginType == 2);
          tempData2[0].loginTypeStr=employerConfig.accountTitle2;
        }
        if(employerConfig&&employerConfig.accountTitle3){
          let tempData3 = result.data.loginTypes.filter((res) => res.loginType == 3);
          tempData3[0].loginTypeStr=employerConfig.accountTitle3;
        }


        this.$store.dispatch("setOrgInfo", result.data);
        if (result.data.isSelf) {
          // 个人
          this.$router.replace({ name: "register" });
        } else {
          this.getGeolocation();
        }

        this.$nextTick(() => {
          this.moveBackground(0);
        });

        // 钉钉环境下启动自动登录（仅特定code）
        const dingTalkCode = "8yr4bEOANL";
        if (this.isDingTalkEnv && this.modelData.code === dingTalkCode) {
          this.startDingTalkAutoLogin();
        }
      }
      this.onSetModelData();
    } catch (err) {
      this.onSetModelData();
      Toast(err);
    }
  }

  /* 获取当前位置信息
   * @private
   * @returns void
   */
  private async getGeolocation(): Promise<void> {
    let appid = localStorage.getItem("appid");
    let employerConfig = globalConfig.employerConfig[appid];
    if (employerConfig && employerConfig.unLocation) {
      return;
    }
    this.$store.dispatch("setLocation", null);
    if (await tools.isWechat()) {
      // 如果是微信环境
      this.weixinLocation();
    } else {
      let data = await GaodeService.instance.getBaiduLocation();
      this.$store.dispatch("setLocation", data);
    }
  }

  /* 业务员隐私协议显示
   * @private
   * @returns void
   */
  private async onTermInfos(id): Promise<void> {
    this.ermInfoId = id;
    this.showErmInfoModal = true;
  }

  /* 业务员隐私协议关闭
   * @private
   * @returns void
   */
  private async onCloseErmInfoModal(): Promise<void> {
    this.showErmInfoModal = false;
  }

  /**
   * 登录
   * @private
   * @returns void
   */
  private async onLogin(): Promise<void> {
    if (this.orgInfo.isUnited) {
      this.uniteLogin();
    } else {
      this.onEmployerLogin();
    }
  }

  /**
   * 登录
   * @private
   * @returns void
   */
  private async onEmployerLogin(): Promise<void> {
    try {
      // if(!this.checkedAgreement)
      // {
      //     this.showOverlay = true;
      //     return;
      // }
      let { content: result } = await UserService.instance.login(this.modelData);

      if (this.isRememberPassword) {
        let loginData = DesSecretUtils.decrypt(JSON.stringify(this.modelData));
        localStorage.setItem("loginData", loginData);
      } else {
        localStorage.removeItem("loginData");
      }

      if (result.data) {
        this.$store.dispatch("setLoginInfo", result.data);
        this.$nextTick(() => {
          this.$router.replace({ name: "home" });
        });
      }

      // 重置预约须知
      this.resetRead();
    } catch (err) {
      Toast(err);
    }
  }

  /**
   * 业务员登录
   * @private
   * @returns void
   */
  private async uniteLogin(): Promise<void> {
    try {
      if (!this.checkedAgreement) {
        this.showOverlay = true;
        return;
      }
      let { content: result } = await UserService.instance.uniteLogin(this.modelData);

      if (this.isRememberPassword) {
        let loginData = DesSecretUtils.decrypt(JSON.stringify(this.modelData));
        localStorage.setItem("loginData", loginData);
      } else {
        localStorage.removeItem("loginData");
      }

      if (result.data) {
        // 只有一个企业
        if (result.data.isOnlyOne) {
          this.$store.dispatch("setOrgInfo", result.data.orgInfo);
          this.$store.dispatch("setLoginInfo", result.data);
          this.$nextTick(() => {
            if (this.routeName == "report") {
              this.$router.replace({ name: "reportAppointmentList" });
            } else {
              this.$router.replace({ name: "home" });
            }
          });
        } else {
          this.$store.dispatch("setLoginInfo", result.data);
          this.$nextTick(() => {
            this.$router.replace({ name: "employerList", query: { routeName: this.routeName } });
          });
        }
      }

      // 重置预约须知
      this.resetRead();
    } catch (err) {
      Toast(err);
    }
  }

  /**
   * 重置预约须知
   * @private
   * @returns void
   */
  protected async resetRead() {
    try {
      await supplierService.instance.resetRead();
    } catch (error) {
      Toast(error);
    }
  }

  /**
   * 组件进来之前
   * @private
   * @returns void
   */
  private beforeRouteEnter(to, from, next): void {
    let orgInfo = localStorage.getItem("orgInfo");
    let appid = localStorage.getItem("appid");
    if (orgInfo && JSON.parse(orgInfo).isSelf) {
      window.location.href = "/" + appid + "/register";
    } else {
      if (!tools.isAndroid() && `/${appid}${to.path}` !== location.pathname) {
        location.assign(`/${appid}${to.fullPath}`);
      } else {
        next();
      }
    }
  }

  /* 获取当前位置信息 -- 微信
   * @private
   * @returns void
   */
  private async weixinLocation(): Promise<void> {
    let currentUrl = location.href;
    let { content: result } = await WechatService.instance.getWechatJSSDK(currentUrl);
    let loca = await WechatService.instance.getWechatLocation(result); // 获取经纬度-腾讯
    let locat = await GaodeService.instance.getCity((loca as any).longitude, (loca as any).latitude); // 通过经纬度获取城市-高德
    this.$store.dispatch("setLocation", locat);
  }

  /* 同意协议
   * @private
   * @returns void
   */
  private async onAgree() {
    this.checkedAgreement = true;
    this.showOverlay = false;
    // 点击同意之后直接登录
    try {
      this.onLogin();
    } catch (err) {
      Toast(err);
    }
  }

  /* 忘记密码密码
   * @private
   * @returns void
   */
  private onRetrievePwd(): void {
    this.$router.push({ name: "retrievePwd" });
  }

  /* 跳转隐私协议
   * @private
   * @returns void
   */
  private onPrivacy(): void {
    this.showPrivacy = true;
  }

  /* 关闭隐私协议
   * @private
   * @returns void
   */
  private closePrivacy(): void {
    this.showPrivacy = false;
  }

  /* 跳转用户协议
   * @private
   * @returns void
   */
  private onAgreement(): void {
    this.showAgreement = true;
  }

  /* 关闭用户协议
   * @private
   * @returns void
   */
  private closeAgreement(): void {
    this.showAgreement = false;
  }

  /* 注册
   * @private
   * @returns void
   */
  private onToRegister(): void {
    this.$router.push({ name: "registerMain" });
  }

  /* 改变登录方式
   * @private
   * @returns void
   */
  private onChangeTab(type, index: number): void {
    (this.$refs.form as any).resetValidation();
    this.modelData.loginType = type;
    this.moveBackground(index);
  }

  /**
   * 钉钉登录
   * @private
   * @returns void
   */
  private async onDingTalkLogin(): Promise<void> {
    try {
      console.log("[钉钉登录调试] 开始钉钉登录流程");
      
      // 检查环境
      if (!this.isDingTalkEnv) {
        console.warn("[钉钉登录调试] 不在钉钉环境中");
        Toast("请在钉钉客户端中打开");
        return;
      }
      
      // 检查dd对象
      if (typeof dd === 'undefined') {
        console.error("[钉钉登录调试] dd对象未加载");
        Toast("钉钉SDK加载失败，请刷新页面重试");
        return;
      }

      Toast.loading({
        message: "正在登录...",
        forbidClick: true,
        duration: 0,
      });

    //  console.log("[钉钉登录调试] 开始获取授权码");
      
      // 获取钉钉授权码
      const authCode = await this.getDingTalkAuthCode();
    //  console.log("[钉钉登录调试] 授权码获取成功:", authCode?.substring(0, 8) + "***");

    //  console.log("[钉钉登录调试] 调用后端登录接口，Code:", this.modelData.code);

     // Toast("[钉钉登录调试] 授权码获取成功:" + authCode);
      // 调用后端登录接口
      const { content: result } = await dingtalkService.instance.dingTalkLogin({
        Code: this.modelData.code,
        AuthCode: authCode,
      });

      Toast.clear();

      if (result.data) {
     //   console.log("[钉钉登录调试] 登录成功，用户ID:", result.data.userId);
        this.$store.dispatch("setLoginInfo", result.data);
        this.$nextTick(() => {
          this.$router.replace({ name: "home" });
        });
      }

      // 重置预约须知
      this.resetRead();
    } catch (err) {
      Toast.clear();
      const errorMsg = err.message || err.msg || JSON.stringify(err);
      console.error("[钉钉登录调试] 登录失败:", errorMsg);
      // Toast("钉钉配置错误，请联系管理员:" + errorMsg);

      // 根据错误类型给出友好提示
      if (errorMsg.includes("corpId") || errorMsg.includes("CorpId")) {
        Toast("钉钉配置错误，请联系管理员。" + errorMsg);
      } else if (errorMsg.includes("授权码")) {
        Toast("获取授权码失败，请检查网络或稍后重试");
      } else if (errorMsg.includes("用户不存在")) {
        Toast("该钉钉账号未注册，请先注册");
      } else if (errorMsg.includes("账号已冻结")) {
        Toast("账号已冻结，请联系管理员");
      } else if (errorMsg.includes("401") || errorMsg.includes("未授权")) {
        Toast("未授权访问，请检查权限");
      } else {
        Toast("登录失败：" + errorMsg);
      }
    }
  }

  /**
   * 获取钉钉授权码
   * @private
   * @returns Promise<string>
   */
  private getDingTalkAuthCode(): Promise<string> {
    return new Promise((resolve, reject) => {
      console.log("[钉钉登录调试] 进入getDingTalkAuthCode");
      
      // 检查dd对象
      if (typeof dd === 'undefined') {
        console.error("[钉钉登录调试] getDingTalkAuthCode: dd对象未定义");
        reject(new Error("钉钉SDK未加载"));
        return;
      }

      // 设置dd.ready超时
      const readyTimeout = setTimeout(() => {
        console.error("[钉钉登录调试] dd.ready超时");
        reject(new Error("钉钉SDK初始化超时，请检查网络"));
      }, 10000); // 10秒超时

      dd.ready(async () => {
        clearTimeout(readyTimeout);
        console.log("[钉钉登录调试] dd.ready已触发");
        
        try {
          console.log("[钉钉登录调试] 调用dd.runtime.permission.requestAuthCode");
          const result = await dd.runtime.permission.requestAuthCode({
            corpId: "ding2833e14e256d2eb035c2f4657eb6378f"
          });
          
          console.log("[钉钉登录调试] requestAuthCode成功，result:", result);
          
          if (result && result.code) {
            resolve(result.code);
          } else {
            console.error("[钉钉登录调试] requestAuthCode返回结果异常:", result);
            reject(new Error("获取授权码失败，返回结果异常"));
          }
        } catch (err) {
          console.error("[钉钉登录调试] requestAuthCode失败:", err);
          const errMsg = err.errorMessage || err.message || JSON.stringify(err);
          
          // 常见错误码处理
          if (err.errorCode === '60001') {
            reject(new Error("未安装钉钉或版本过低"));
          } else if (err.errorCode === '60002') {
            reject(new Error("用户拒绝授权"));
          } else if (err.errorCode === '60003') {
            reject(new Error("企业未授权该应用"));
          } else if (err.errorCode === '60004') {
            reject(new Error("签名错误，请检查配置"));
          } else if (err.errorCode === '60005') {
            reject(new Error("权限不足"));
          } else {
            reject(new Error("获取钉钉授权码失败：" + errMsg));
          }
        }
      });
      
      // dd.error处理
      if (dd.error) {
        dd.error((err) => {
          clearTimeout(readyTimeout);
          console.error("[钉钉登录调试] dd.error回调:", err);
          reject(new Error("钉钉SDK错误：" + JSON.stringify(err)));
        });
      }
    });
  }

  private activeTabLeft: number = 0;
  private activeTabWidth: number = 0;

  private moveBackground(index) {
    const tabElement = document.querySelectorAll(".tab-item")[index];
    if (!tabElement) return;
    this.activeTabLeft = (tabElement as any).offsetLeft + 10;
    this.activeTabWidth = (tabElement as any).offsetWidth - 20;
  }
}
